
<script>
import {inView, scrollTo} from '@/common/util';
import transitionFade from '@/components/transition/fade';
export default {
	data() {
		return {
			show: false,
			submit: null,
			form: null
		};
	},
	created() {
		window.addEventListener('scroll', () => {
			this.update();
		});
	},
	methods: {
		getSubmit() {
			if (this.submit) {
				return this.submit;
			}
			this.submit = document.querySelector('#submit');
			return this.submit;
		},
		getForm() {
			if (this.form) {
				return this.form;
			}
			this.form = document.querySelector('#form');
			return this.form;
		},
		update() {
			if (inView(this.getSubmit())) {
				this.show = false;
				return;
			}
			this.show = true;
		},
		toForm() {
			const scrollTop = document.documentElement.scrollTop;
			const clientHeight = document.documentElement.clientHeight;
			const formHeight = this.getForm().offsetHeight;
			const formTop = this.getForm().getBoundingClientRect().top;
			scrollTo(scrollTop + formTop - ((clientHeight - formHeight) / 2), 100);
		},
		click() {
			this.toForm();
		}
	},
	mounted() {
		this.update();
	},
	components: {
		transitionFade
	}
}
</script>

<template>
	<transition-fade>
		<div class="footer-submit" v-if="show" @click="click">
			立即预约咨询
			<i></i>
			<i></i>
			<i></i>
		</div>
	</transition-fade>
</template>
<style lang="stylus" scoped>
.footer-submit
	position fixed
	left 0
	right 0
	bottom 0
	margin 0 auto
	max-width 20rem
	width 100%
	height 2.66rem
	background linear-gradient(135deg,rgba(255,168,0,1) 0%,rgba(255,60,0,1) 100%)
	text-align center
	line-height 2.66rem
	color #fff
	font-size 0.96rem
	font-weight 600
	overflow hidden
	z-index 10
i
	position absolute
	display block
	background linear-gradient(90deg,rgba(250,217,97,1) 0%,rgba(255,60,0,0) 100%)
	transform rotate(-23deg)
	&:first-child
		top 0
		left 1.22rem
		width 5.7rem
		height 1.06rem
		border-radius 10px
		opacity 0.46
	&:nth-child(2)
		top 0.58rem
		left 4.9rem
		width 11.78rem
		height 1.65rem
		border-radius 16px
		opacity 0.34
	&:last-child
		top 0.21rem
		right 0
		width 6.66rem
		height 1.06rem
		border-radius 8px
		opacity 0.45
</style>